import React, { FC } from 'react';
import { Redirect, useLocation } from 'react-router-dom';

type Props = {
  to: string;
};

/**
 * The Redirect in base react-router-dom does not pass along the query (query) params
 * Do not add functionality outside of redirecting with params here. If you want to do that, make a new component.
 */
const RedirectWithQueryParams: FC<Props> = ({ to }: Props) => {
  const { search } = useLocation();
  /* Do not add functionality outside of redirecting with params here. */
  return <Redirect to={`${to}${search}`} />;
};

export default RedirectWithQueryParams;
